"use client";

import { Input as _Input, InputProps } from "@heroui/input";
import { Button as _Button, ButtonProps } from "@heroui/button";
import { Select as _Select, cn, TooltipProps } from "@heroui/react";
import { Snippet as _snippet } from "@heroui/snippet";
import { useState } from "react";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa6";
import { SnippetProps } from "@heroui/snippet";
import { useFormStatus } from "react-dom";
import FieldsetInput from "./input";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Tooltip as _Tooltip } from "@heroui/react";
export const Snippet = (props: SnippetProps) => {
  return (
    <_snippet
      symbol=""
      size="md"
      tooltipProps={{
        color: "foreground",
        content: "Copy referral code",
        disableAnimation: true,
        placement: "right",
        closeDelay: 0,
      }}
      radius="sm"
      className="pl-4"
      fullWidth
      {...props}
    />
  );
};

export const Input = (props: InputProps) => {
  const { pending } = useFormStatus();
  return (
    <FieldsetInput
      // labelPlacement="outside"
      // labelPlacement="outside"
      // size="lg"
      radius="sm"
      fullWidth
      variant="bordered"
      isDisabled={pending}
      // classNames={{
      //   base: clsx(""),
      //   input: clsx("placeholder:text-[#BBBBBB]"),
      //   inputWrapper: clsx("bg-white border-1 border-[#D8D8D8]"),
      // }}
      // className="w-full"
      {...props}
    />
  );
};

export const SecurityPinInput = (props: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [value, setValue] = useState<string>("");
  return (
    (<_Input
      labelPlacement="outside"
      size="lg"
      radius="sm"
      variant="bordered"
      onValueChange={(v) => {
        if (v.length <= 6 && /^\d+$/.test(v)) setValue(v);
      }}
      value={value}
      type={showPassword ? "text" : "password"}
      classNames={{
        base: cn(""),
        input: cn("placeholder:text-[#BBBBBB]"),
        inputWrapper: cn("bg-white border-1 border-[#D8D8D8]"),
      }}
      className="w-full"
      startContent={<FaLock color="#FFCA05" size={16} />}
      endContent={
        <a className="cursor-pointer" onClick={() => setShowPassword((p) => !p)}>
          {showPassword ? <FaEye color="#8D8D8D" size={16} /> : <FaEyeSlash color="#8D8D8D" size={16} />}
        </a>
      }
      {...props}
    />)
  );
};

export const PasswordInput = (props: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const { pending } = useFormStatus();

  return (
    <FieldsetInput
      fullWidth
      // labelPlacement="outside"
      // labelPlacement="inside"
      // size="md"
      // size="lg"
      // radius="sm"
      // variant="bordered"
      type={showPassword ? "text" : "password"}
      // classNames={{
      // base: clsx(""),
      // input: clsx("placeholder:text-[#BBBBBB]"),
      // inputWrapper: clsx("border-1 border-[#D8D8D8]"),
      // }}
      // className="w-full"
      // classNames={{
      //   label: clsx("text-tiny"),
      // }}
      // startContent={<FaLock color="#8D8D8D" size={16} />}
      endContent={
        <a className="cursor-pointer" onClick={() => setShowPassword((p) => !p)}>
          {/* {showPassword ? <FaEye color="#8D8D8D" size={16} /> : <FaEyeSlash color="#8D8D8D" size={16} />} */}
          {showPassword ? (
            <span className="icon-icon10" color="#8D8D8D" />
          ) : (
            <span className="icon-icon9" color="#8D8D8D" />
          )}
        </a>
      }
      isDisabled={pending}
      {...props}
    />
  );
};

export const Button = (props: ButtonProps & { isForm?: boolean }) => {
  // to use useFormStatus() hook, you MUST wrap the form handler with action attribute. Otherwise, it will not work.
  const { pending } = useFormStatus();
  return (
    <_Button
      // size="md"
      isDisabled={pending}
      color="primary"
      // radius="sm"
      fullWidth
      className="text-base font-bold"
      {...props}
    >
      {pending && props.isForm ? (
        <AiOutlineLoading3Quarters size={24} color="#fff" className="animate-spin" />
      ) : (
        props.children
      )}
    </_Button>
  );
};

// export const CountrySelect = (props: Omit<SelectProps, "children">) => {
//   const [flag, setFlag] = useState<string>("MY");
//   return (
//     <_Select
//       size="md"
//       radius="sm"
//       variant="bordered"
//       classNames={{
//         // value: clsx("placeholder:text-[#BBBBBB]"),
//         trigger: clsx("border-1 border-[#D8D8D8] bg-white"),
//       }}
//       value={"+00"} //
//       placeholder="+00"
//       startContent={<div className={clsx("aspect-square !h-[1.5rem] !w-auto rounded-full", `flag:${flag}`)} />}
//       {...props}
//       items={Object.entries(countries)
//         .map(([key, value]) => ({
//           key,
//           label: `+${value.phone[0]}`,
//           flag: <div className={clsx("aspect-square !h-[1.5rem] !w-auto rounded-full", `flag:${key}`)} />,
//         }))
//         .sort((a, b) => a.label.localeCompare(b.label))}
//       onSelectionChange={(item) => {
//         // console.log(item);
//         setFlag(item.currentKey as string);
//       }}
//     >
//       {(item) => (
//         <SelectItem key={item.key} value={item.label} startContent={item.flag}>
//           {item.label}
//         </SelectItem>
//       )}
//     </_Select>
//   );
// };

export const Tooltip = (props: TooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <_Tooltip isOpen={isOpen} onOpenChange={(open) => setIsOpen(open)} {...props}></_Tooltip>;
};
